import { GetStaticProps, NextPage } from "next";
import AboutUsView from "@components/views/AboutUsView/view";
import Head from "next/head";

const AboutUsPage: NextPage = () => {
	return (
		<>
			<Head>
				<title>О нас — Selfschool</title>
				<meta
					name="description"
					content="Selfschool — проект для людей, которые любят учиться и обмениваться знаниями. Мы не просто маркетплейс курсов, где вы можете разместить свой курс или обучиться чему-то новому, мы создаем сообщество людей, которые хотят развиваться, обмениваться опытом и получать от этого удовольствие."
				/>
			</Head>
			<AboutUsView />
		</>
	);
};

export const getStaticProps: GetStaticProps = async () => {
	return {
		props: {},
	};
};

export default AboutUsPage;
